"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstOrDefaultPaymentMethodForProcessor = exports.isDefaultPaymentMethod = exports.isPaymentMethodAcceptedByProcessor = exports.getTitleForPaymentMethod = exports.paymentMethodTypeFromString = exports.isValid = exports.isValidExpiration = exports.isValidCVV = exports.getCardTypeFromNumber = void 0;
const types = require("../types");
const isSubstringValueBetween = (str, length, minNumber, maxNumber) => {
    const prefix = Number(str.substr(0, length));
    return minNumber <= prefix && prefix <= maxNumber;
};
const getCardTypeFromNumber = (cardNumber) => {
    const isBetween = isSubstringValueBetween.bind(null, cardNumber);
    const isVisa = cardNumber.startsWith('4');
    const isAmex = cardNumber.startsWith('34') || cardNumber.startsWith('37');
    const isDiscover = cardNumber.startsWith('6011') ||
        cardNumber.startsWith('65') ||
        isBetween(6, 622126, 622925) ||
        isBetween(3, 644, 649);
    const isMastercard = isBetween(2, 51, 55) || isBetween(4, 2221, 2720);
    if (isVisa) {
        return types.CreditCardType.visa;
    }
    else if (isAmex) {
        return types.CreditCardType.americanExpress;
    }
    else if (isDiscover) {
        return types.CreditCardType.discover;
    }
    else if (isMastercard) {
        return types.CreditCardType.masterCard;
    }
    else {
        return types.CreditCardType.unknown;
    }
};
exports.getCardTypeFromNumber = getCardTypeFromNumber;
const isValidCVV = (cvv) => cvv.length >= 3;
exports.isValidCVV = isValidCVV;
const isValidExpiration = (expiration) => expiration.length === 4;
exports.isValidExpiration = isValidExpiration;
const isValid = (card) => {
    return ((0, exports.isValidCVV)(card.cvv) && (0, exports.isValidExpiration)(card.expiration) && card.cardNumber.length > 14 && card.zip.length === 5);
};
exports.isValid = isValid;
const PAYMENT_METHOD_TYPE_MAP = {
    card: types.PaymentMethodType.Card,
    applePay: types.PaymentMethodType.ApplePay,
    venmo: types.PaymentMethodType.Venmo,
    payPal: types.PaymentMethodType.PayPal,
    googlePay: types.PaymentMethodType.GooglePay,
};
const paymentMethodTypeFromString = (paymentMethodType) => {
    return PAYMENT_METHOD_TYPE_MAP[paymentMethodType] || types.PaymentMethodType.Unknown;
};
exports.paymentMethodTypeFromString = paymentMethodTypeFromString;
const getTitleForPaymentMethod = (paymentMethod) => {
    if (paymentMethod.type === types.PaymentMethodType.Card) {
        return `•••• ${paymentMethod.identifier}`;
    }
    else {
        return paymentMethod.identifier;
    }
};
exports.getTitleForPaymentMethod = getTitleForPaymentMethod;
const isPaymentMethodAcceptedByProcessor = (paymentMethod, processor) => {
    return paymentMethod.supportedProcessors.includes(processor);
};
exports.isPaymentMethodAcceptedByProcessor = isPaymentMethodAcceptedByProcessor;
const isDefaultPaymentMethod = (paymentMethod) => {
    return paymentMethod.isDefault;
};
exports.isDefaultPaymentMethod = isDefaultPaymentMethod;
const findFirstOrDefaultPaymentMethodForProcessor = (paymentMethods, processor) => {
    const acceptedPaymentMethod = paymentMethods.filter((p) => (0, exports.isPaymentMethodAcceptedByProcessor)(p, processor));
    const defaultPaymentMethod = acceptedPaymentMethod.find(exports.isDefaultPaymentMethod);
    return defaultPaymentMethod !== null && defaultPaymentMethod !== void 0 ? defaultPaymentMethod : acceptedPaymentMethod[0];
};
exports.findFirstOrDefaultPaymentMethodForProcessor = findFirstOrDefaultPaymentMethodForProcessor;
//# sourceMappingURL=payments.js.map